import { default as DiscountCodeUsers } from './DiscountCodeUsers'
import { default as UploadOdometerData } from './UploadOdometerData'
import { default as UploadOdometerDataReason } from './UploadOdometerDataReason'
import { default as ReservationForward } from './ReservationForward'
import { default as TableColumnsManager } from './TableColumnsManager'
import { default as NotificationPreview } from './NotificationPreview'

export const Modals = {
    DiscountCodeUsers,
    UploadOdometerData,
    UploadOdometerDataReason,
    ReservationForward,
    TableColumnsManager,
    NotificationPreview
}

export { default } from './Modal'